<template>
  <div>
    <link
      rel="stylesheet"
      id="styles-css"
      href="/static/landing/silcsbio_style.css"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="hero-css"
      href="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/stylesheets/hero.css?ver=5.8.1"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="link_list_detail-css"
      href="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/stylesheets/link_list_detail.css?ver=5.8.1"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="image_content-css"
      href="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/stylesheets/image_content.css?ver=5.8.1"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="logo_carousel-css"
      href="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/stylesheets/logo_carousel.css?ver=5.8.1"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="featured_posts-css"
      href="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/stylesheets/featured_posts.css?ver=5.8.1"
      type="text/css"
      media="all"
    />

    <header class="site-header" style="border-bottom: 1px solid #9bafd1">
      <!-- <div class="site-header__notification">
        <p>
          Application of SILCS to potassium channel hERG1
          <a href="https://pubs.acs.org/doi/pdf/10.1021/acs.jcim.0c01065"
            >read more here.</a
          >
        </p>
      </div> -->

      <div class="site-header--mobile">
        <div class="container">
          <div class="site-header__logo">
            <h1>
              <a href="https://silcsbio.com" class="site-header--mobile__logo">
                <img src="/static/landing/silcs_bio_logo.svg" alt="" />
              </a>
            </h1>
          </div>
          <button
            class="nav__button--mobile"
            id="menuButton"
            aria-controls="mobile-menu"
          >
            <span class="icon">
              <svg
                class="svg-inline--fa fa-bars fa-w-14"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="bars"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"
                ></path></svg
              ><!-- <i class="far fa-bars"></i> -->
              <svg
                class="svg-inline--fa fa-times fa-w-10"
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="times"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                ></path></svg
              ><!-- <i class="fal fa-times"></i> -->
            </span>
          </button>
          <nav class="site-header__navigation mobile-menu" id="mobile-menu">
            <ul id="menu-footer-navigation" class="menu">
              <li
                id="menu-item-531"
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-531
                "
              >
                <a href="https://silcsbio.com/software/">Software</a>
              </li>
              <li
                id="menu-item-530"
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-530
                "
              >
                <a href="https://silcsbio.com/services/">Services</a>
              </li>
              <li
                id="menu-item-532"
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-532
                "
              >
                <a href="https://silcsbio.com/platform-technology/"
                  >Platform Technology</a
                >
              </li>
              <li
                id="menu-item-533"
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="/SILCS-Interactive-Demo">Interactive Demo</a>
              </li>
              <li
                id="menu-item-533"
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="https://silcsbio.com/team/">Team</a>
              </li>
              <li
                id="menu-item-378"
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-378
                "
              >
                <a href="https://silcsbio.com/news/">News</a>
              </li>
              <li
                id="menu-item-474"
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-474
                "
              >
                <a href="https://silcsbio.com/contact-us/">Contact Us</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="slicknav_menu">
          <a
            href="#"
            aria-haspopup="true"
            tabindex="0"
            class="slicknav_btn slicknav_collapsed"
            style="outline: none"
            ><span class="slicknav_menutxt"></span
            ><span class="slicknav_icon slicknav_no-text"
              ><span class="slicknav_icon-bar"></span
              ><span class="slicknav_icon-bar"></span
              ><span class="slicknav_icon-bar"></span></span
          ></a>
          <nav
            class="slicknav_nav slicknav_hidden"
            style="display: none"
            aria-hidden="true"
            role="menu"
          >
            <ul class="menu">
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-531
                "
              >
                <a href="https://silcsbio.com/software/" role="menuitem"
                  >Software</a
                >
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-530
                "
              >
                <a href="https://silcsbio.com/services/" role="menuitem"
                  >Services</a
                >
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-532
                "
              >
                <a
                  href="https://silcsbio.com/platform-technology/"
                  role="menuitem"
                  >Platform Technology</a
                >
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="/SILCS-Interactive-Demo">Interactive Demo</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="https://silcsbio.com/team/" role="menuitem">Team</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-378
                "
              >
                <a href="https://silcsbio.com/news/" role="menuitem">News</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-474
                "
              >
                <a href="https://silcsbio.com/contact-us/" role="menuitem"
                  >Contact Us</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="site-header--desktop">
        <div class="container">
          <div class="site-header__logo">
            <h1>
              <a href="https://silcsbio.com" class="site-header--desktop__logo">
                <img
                  src="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/images/silcs_bio_logo.svg"
                  alt=""
                />
              </a>
            </h1>
          </div>
          <nav class="site-header__navigation">
            <ul id="menu-footer-navigation-1" class="menu">
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-531
                "
              >
                <a href="https://silcsbio.com/software/">Software</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-530
                "
              >
                <a href="https://silcsbio.com/services/">Services</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-532
                "
              >
                <a href="https://silcsbio.com/platform-technology/"
                  >Platform Technology</a
                >
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="/SILCS-Interactive-Demo">Interactive Demo</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type_archive
                  menu-item-object-team menu-item-533
                "
              >
                <a href="https://silcsbio.com/team/">Team</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-378
                "
              >
                <a href="https://silcsbio.com/news/">News</a>
              </li>
              <li
                class="
                  menu-item
                  menu-item-type-post_type
                  menu-item-object-page menu-item-474
                "
              >
                <a href="https://silcsbio.com/contact-us/">Contact Us</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>

    <div class="container0">
      <v-app class="container">
        <home-view />
      </v-app>
    </div>
    <footer class="site-footer">
      <div class="container">
        <div class="site-footer__logo">
          <a href="https://silcsbio.com">
            <img
              src="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/images/silcs_bio_logo_white.svg"
              alt=""
            />
          </a>
          <p>© 2021 SilcsBio, LLC</p>
        </div>
        <div class="site-footer__info">
          <div class="site-footer__info__item">
            <div class="icon">
              <svg
                class="svg-inline--fa fa-map-marker-alt fa-w-12"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="map-marker-alt"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272zm-80-272c0-44.183 35.817-80 80-80s80 35.817 80 80-35.817 80-80 80-80-35.817-80-80z"
                ></path></svg
              ><!-- <i class="far fa-map-marker-alt"></i> -->
            </div>
            <div class="info">
              <address>
                1100 Wicomico Street, Suite 323<br />
                Baltimore, MD 21230
              </address>
            </div>
          </div>

          <div class="site-footer__info__item">
            <div class="icon">
              <svg
                class="svg-inline--fa fa-phone fa-w-16"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="phone"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M476.5 22.9L382.3 1.2c-21.6-5-43.6 6.2-52.3 26.6l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l40 32.7C311 267.8 267.8 311 215.4 339.5l-32.7-40c-12.8-15.7-34.8-21.1-53.4-13.1L27.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5C312.3 512 512 313.7 512 67.5c0-21.4-14.6-39.8-35.5-44.6zM69.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c98.8-46.4 150.6-98 197-197l-68.1-55.7 42.1-98.2L464 69.3C463 286.9 286.9 463 69.3 464z"
                ></path></svg
              ><!-- <i class="far fa-phone"></i> -->
            </div>
            <div class="info">
              <p>(410) 401-9794</p>
            </div>
          </div>

          <div class="site-footer__info__item">
            <div class="icon">
              <svg
                class="svg-inline--fa fa-envelope fa-w-16"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="envelope"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                ></path></svg
              ><!-- <i class="far fa-envelope"></i> -->
            </div>
            <div class="info">
              <a href="mailto:info@silcsbio.com">info@silcsbio.com</a>
            </div>
          </div>
        </div>
        <div class="site-footer__follow">
          Stay Up To Date with Our Newsletter
          <!-- Begin Mailchimp Signup Form -->
          <div id="mc_embed_signup">
            <form
              action="https://silcsbio.us20.list-manage.com/subscribe/post?u=379cf265f1393f814c818748b&amp;id=d4a5341be3"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_blank"
              novalidate=""
            >
              <div id="mc_embed_signup_scroll">
                <label for="mce-EMAIL">Sign Up</label>
                <div class="footer-form__inner">
                  <input
                    type="email"
                    value=""
                    name="EMAIL"
                    class="email"
                    id="mce-EMAIL"
                    placeholder="Email Address *"
                    required=""
                    style="background-color: white"
                  />
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_379cf265f1393f814c818748b_d4a5341be3"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                  <input
                    type="submit"
                    value="Sign Up"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    class="button btn"
                  />
                </div>
              </div>
            </form>
          </div>

          <!--End mc_embed_signup-->
          <div class="site-footer__social">
            <p>Follow Us:</p>
            <ul>
              <li>
                <a href="https://twitter.com/silcsbio" target="_blank"
                  ><svg
                    class="svg-inline--fa fa-twitter fa-w-16"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="twitter"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                    ></path></svg
                  ><!-- <i class="fab fa-twitter"></i> --></a
                >
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/silcsbio-llc/"
                  target="_blank"
                  ><svg
                    class="svg-inline--fa fa-linkedin fa-w-14"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="linkedin"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                    ></path></svg
                  ><!-- <i class="fab fa-linkedin"></i> --></a
                >
              </li>
            </ul>
            <!-- <ul>
                <li><a href="https://twitter.com/silcsbio" target="_blank"><i class="fab fa-twitter"></i></a></li>
                <li><a href="https://www.linkedin.com/company/silcsbio-llc/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                </ul> -->
          </div>
        </div>
      </div>
      <div class="site-footer__subfooter">
        <a href="https://www.earlycharm.com/" target="_blank"
          ><img
            src="https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/images/logo_early_charm_footer.jpg"
            alt="Supported by Early Charm"
        /></a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "LandingLayout",

  components: {
    // HomeAppBar: () => import("@/layouts/home/AppBar"),
    // HomeFooter: () => import("@/layouts/home/Footer"),
    HomeView: () => import("@/layouts/home/View"),
  },
  mounted() {
    let silcsScript = document.createElement("script");
    silcsScript.setAttribute(
      "src",
      "https://silcsbio.com/wp-content/themes/sil-silcs-bio/dist/scripts/scripts.js"
    );
    document.head.appendChild(silcsScript);
  },
};
</script>

<style scoped>
/* .container0 div {
  background: transparent !important;
}
.container0 {
  margin: 0;
  background-image: url("/static/landing/background.png");
  background-size: contain;
} */
.container {
  /* min-width: 1022px; */
  padding: 0;
}
</style>
<style type="text/css">
svg:not(:root).svg-inline--fa {
  overflow: visible;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.225em;
}
.svg-inline--fa.fa-w-1 {
  width: 0.0625em;
}
.svg-inline--fa.fa-w-2 {
  width: 0.125em;
}
.svg-inline--fa.fa-w-3 {
  width: 0.1875em;
}
.svg-inline--fa.fa-w-4 {
  width: 0.25em;
}
.svg-inline--fa.fa-w-5 {
  width: 0.3125em;
}
.svg-inline--fa.fa-w-6 {
  width: 0.375em;
}
.svg-inline--fa.fa-w-7 {
  width: 0.4375em;
}
.svg-inline--fa.fa-w-8 {
  width: 0.5em;
}
.svg-inline--fa.fa-w-9 {
  width: 0.5625em;
}
.svg-inline--fa.fa-w-10 {
  width: 0.625em;
}
.svg-inline--fa.fa-w-11 {
  width: 0.6875em;
}
.svg-inline--fa.fa-w-12 {
  width: 0.75em;
}
.svg-inline--fa.fa-w-13 {
  width: 0.8125em;
}
.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}
.svg-inline--fa.fa-w-15 {
  width: 0.9375em;
}
.svg-inline--fa.fa-w-16 {
  width: 1em;
}
.svg-inline--fa.fa-w-17 {
  width: 1.0625em;
}
.svg-inline--fa.fa-w-18 {
  width: 1.125em;
}
.svg-inline--fa.fa-w-19 {
  width: 1.1875em;
}
.svg-inline--fa.fa-w-20 {
  width: 1.25em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: 0.3em;
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: 0.3em;
  width: auto;
}
.svg-inline--fa.fa-border {
  height: 1.5em;
}
.svg-inline--fa.fa-li {
  width: 2em;
}
.svg-inline--fa.fa-fw {
  width: 1.25em;
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.fa-layers-counter,
.fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: #ff253a;
  border-radius: 1em;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  height: 1.5em;
  line-height: 1;
  max-width: 5em;
  min-width: 1.5em;
  overflow: hidden;
  padding: 0.25em;
  right: 0;
  text-overflow: ellipsis;
  top: 0;
  -webkit-transform: scale(0.25);
  transform: scale(0.25);
  -webkit-transform-origin: top right;
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: 0;
  right: 0;
  top: auto;
  -webkit-transform: scale(0.25);
  transform: scale(0.25);
  -webkit-transform-origin: bottom right;
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: 0;
  left: 0;
  right: auto;
  top: auto;
  -webkit-transform: scale(0.25);
  transform: scale(0.25);
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
}

.fa-layers-top-right {
  right: 0;
  top: 0;
  -webkit-transform: scale(0.25);
  transform: scale(0.25);
  -webkit-transform-origin: top right;
  transform-origin: top right;
}

.fa-layers-top-left {
  left: 0;
  right: auto;
  top: 0;
  -webkit-transform: scale(0.25);
  transform: scale(0.25);
  -webkit-transform-origin: top left;
  transform-origin: top left;
}

.fa-lg {
  font-size: 1.3333333333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  -webkit-animation: fa-spin 1s infinite steps(8);
  animation: fa-spin 1s infinite steps(8);
}

@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  -webkit-transform: scale(-1, 1);
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  -webkit-transform: scale(1, -1);
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  -webkit-transform: scale(-1, -1);
  transform: scale(-1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  -webkit-filter: none;
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: #fff;
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: 1;
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: 0.4;
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: 0.4;
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: 1;
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse {
  color: #fff;
}

/* modified */
p {
  line-height: inherit !important;
  margin-top: inherit !important;
  margin-bottom: inherit !important;
  font-size: inherit !important;
  color: inherit !important;
}
.btn {
  display: inline-flex !important;
  margin-top: 0 !important;
}
.v-main__wrap {
  background-color: #fff;
}
</style>